import React, { useEffect, useState } from "react";
import { parseISO, format } from "date-fns";
import { useHistory } from "react-router-dom";

const CustomerQuote = (props) => {
	const { cars, drivers, makeModels } = props;
	const [models, setModels] = useState([]);
	let history = useHistory();

	useEffect(() => {
		if (makeModels) {
			let thisModels = JSON.parse(makeModels);

			thisModels = thisModels.map((model) => (
				<option value={model.id} key={model.id}>
					{model.make_name}
				</option>
			));
			setModels(thisModels);
		}
	}, [makeModels]);

	const getVehicleMake = (id) => {
		let thisModels = JSON.parse(makeModels);
		const vehicle = thisModels.find((model) => model.id == id);
		return vehicle ? vehicle.make_name : "";
	};

	return (
		<>
			<div className="align-items-baseline col d-flex justify-content-between">
				<h2>Customer</h2>
				<p
					type="button"
					className="mb-0"
					style={{ color: "#01788A" }}
					onClick={() => history.goBack()}
				>
					<u>Start Over</u>
				</p>
			</div>
			{drivers && drivers.length > 0 && (
				<div className="col-12 d-flex">
					<div className="card mb-3 otmt-1 col">
						<div className="card-body d-flex otmt-1">
							<div className="col pl-0">
								<div className="d-flex">
									<div className="">
										<h2 className="circle pt-3 pt-md-2 text-center mb-0">
											{drivers[0].first_name.charAt(0)}
											{drivers[0].last_name.charAt(0)}
										</h2>
									</div>
									<div className="col-11 mt-3 mt-md-0 pl-3">
										<span className="mb-0 mt-0 h3" id="name">
											{drivers[0].first_name}
										</span>
										<span className="ml-2 mb-0 mt-0 h3" id="last-name">
											{drivers[0].last_name}
										</span>
									</div>
								</div>
								<div className="col-12 d-lg-flex ml-5">
									<div className="col-lg-6">
										<div className="otmb-2">
											<p className="">#NPD-423-9386 Expired</p>
											<p className="mb-1">
												{format(parseISO(drivers[0].date_of_birth), "PPP")}
											</p>
											<p className="mb-1" id="e-mail">
												{drivers[0].email}
											</p>
											<p className="mb-1">{drivers[0].phone}</p>
											<p className="mb-1" id="the-city">
												{drivers[0].street}
											</p>
											<p className="mb-1">
												<span id="the-city"> {drivers[0].city}</span>,
												<span id="the-state"> {drivers[0].state}</span>
												<span id="zip-code"> {drivers[0].zip}</span>
											</p>
										</div>
									</div>
									<div className="col-lg-6">
										<div>
											<p style={{ textTransform: "uppercase" }}>Vehicles</p>
										</div>
										{cars.map((car, i) => (
											<div key={i} className="">
												<p className="mb-1">
													{car.year} {getVehicleMake(car.make)} {car.car_model}
												</p>
											</div>
										))}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
};

export default CustomerQuote;
